export default __webpack_public_path__ + "static/Knockout-54Sumo-88b0ffcf0f091b07177c432e3a6a4dac.otf";